import { BrowserModule } from '@angular/platform-browser';
import { NgModule, enableProdMode } from '@angular/core';
import { LocationStrategy, PathLocationStrategy, DatePipe } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AppComponent } from './app.component';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthGuard } from './guards/auth.guard';
import { LoadingModule } from 'ngx-loading';
import { SharedCustomModule } from './shared.module';
import {
    AuthenticationService, ReportsService,
    FileUploadService, RoleService,
    OptionService, PermissionService,
    PermissioncategoryService,
    UsersService, Plant_listsService, Alarm_codesService,
    LoaderService, TranslateLanguageService, Machine_logsService,
    FileExportService
} from './services/index';
// Import containers
import { FullLayoutComponent, SimpleLayoutComponent } from './containers';

// Import routing module
import { AppRoutingModule } from './app.routing';

// Import 3rd party components
import { BsDropdownModule, TabsModule, ProgressbarModule  } from 'ngx-bootstrap';
import { JwtInterceptor } from './guards/JwtInterceptor';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { ToastModule } from 'ng2-toastr';
import { ToastOptions } from 'ng2-toastr';

export class CustomOption extends ToastOptions {
    toastLife: 3000;
    dismiss: 'auto';
    animate = 'flyRight';
    newestOnTop = false;
    showCloseButton = true;
}

import 'hammerjs';
enableProdMode();
const APP_CONTAINERS = [
    FullLayoutComponent,
    SimpleLayoutComponent
]

// Import components
import {
    AppAsideComponent,
    AppBreadcrumbsComponent,
    AppFooterComponent,
    AppHeaderComponent,
    AppSidebarComponent,
    AppSidebarFooterComponent,
    AppSidebarFormComponent,
    AppSidebarHeaderComponent,
    AppSidebarMinimizerComponent,
    APP_SIDEBAR_NAV
} from './components';

const APP_COMPONENTS = [
    AppAsideComponent,
    AppBreadcrumbsComponent,
    AppFooterComponent,
    AppHeaderComponent,
    AppSidebarComponent,
    AppSidebarFooterComponent,
    AppSidebarFormComponent,
    AppSidebarHeaderComponent,
    AppSidebarMinimizerComponent,
    //    AppSubSidebarComponent,
    APP_SIDEBAR_NAV
]



// Import directives
import {
    AsideToggleDirective,
    NAV_DROPDOWN_DIRECTIVES,
    ReplaceDirective,
    SIDEBAR_TOGGLE_DIRECTIVES
} from './directives';
import { TermsOfUseDialogComponent } from './components/terms-of-use-dialog/terms-of-use-dialog.component';

const APP_DIRECTIVES = [
    AsideToggleDirective,
    NAV_DROPDOWN_DIRECTIVES,
    ReplaceDirective,
    SIDEBAR_TOGGLE_DIRECTIVES
]
export function HttpLoaderFactory(httpClient: HttpClient) {
    return new TranslateHttpLoader(httpClient);
}

@NgModule({
    imports: [
        BrowserModule,
        AppRoutingModule,
        TabsModule.forRoot(),
        BsDropdownModule.forRoot(),
        ProgressbarModule.forRoot(),
        BrowserAnimationsModule,
        HttpClientModule,
        LoadingModule,
        SharedCustomModule,
        NgbModule.forRoot(),
        ToastModule.forRoot(),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (HttpLoaderFactory),
                deps: [HttpClient]
            }
        }),

    ],
    declarations: [
        AppComponent,
        ...APP_CONTAINERS,
        ...APP_COMPONENTS,
        ...APP_DIRECTIVES,
        TermsOfUseDialogComponent,

    ],

    providers: [
        AuthGuard,
        LoaderService,

        AuthenticationService,
        UsersService,
        Plant_listsService,
        ReportsService,
        FileUploadService,
        RoleService,
        OptionService,
        PermissionService,
        Alarm_codesService,
        PermissioncategoryService,
        Machine_logsService,
        FileExportService,
        DatePipe,
        
        TranslateLanguageService,
        { provide: LocationStrategy, useClass: PathLocationStrategy },
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        { provide: ToastOptions, useClass: CustomOption }
    ],
    bootstrap: [AppComponent],
    entryComponents: [TermsOfUseDialogComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /var/www/midac/midac-live/app/src/app/app.module.ts